/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Processing_TimeoutInputs */

const cs_gallery_processing_timeout = /** @type {(inputs: Gallery_Processing_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotka se ještě zpracovává — obnovte stránku za chvíli.`)
};

const en_gallery_processing_timeout = /** @type {(inputs: Gallery_Processing_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo is still processing — refresh in a moment.`)
};

/**
* | output |
* | --- |
* | "Photo is still processing — refresh in a moment." |
*
* @param {Gallery_Processing_TimeoutInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_processing_timeout = /** @type {((inputs?: Gallery_Processing_TimeoutInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Processing_TimeoutInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_processing_timeout(inputs)
	return cs_gallery_processing_timeout(inputs)
});